import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import firestore from "../firebase.config";
import Box from '@material-ui/core/Box';
import { makeStyles } from "@material-ui/core/styles";
import {
    Grid,
    Container,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
    Button,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import "../App.css";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: "5vh",
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

export default function Account() {
    const classes = useStyles();
    const { currentUser, logout } = useAuth();
    const history = useHistory();
    const [expanded, setExpanded] = React.useState(false);
    const [userinfo, setUserInfo] = useState();

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const getUserDetail = async (uID) => {
        const userRef = await firestore.collection("users").doc(uID).get();
        const data = userRef.data();
        setUserInfo(data);
    };

    async function handleLogout() {
        try {
            await logout();
            history.push("/login");
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getUserDetail(currentUser.uid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container component="main" maxWidth="sm">
            {userinfo && (
                <div className={classes.root}>
                    <Accordion
                        expanded={expanded === "panel1"}
                        onChange={handleChange("panel1")}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <Typography className={classes.heading}>
                                Name
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {userinfo.fname} {userinfo.lname}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container justify="flex-end">
                                <Button
                                    size="small"
                                    component={Link}
                                    to="/update-profile"
                                    variant="contained"
                                    color="primary"
                                >
                                    Edit
                                </Button>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        expanded={expanded === "panel2"}
                        onChange={handleChange("panel2")}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                        >
                            <Typography className={classes.heading}>
                                Email Address
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {currentUser.email}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                The email address is not able to be amended.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        expanded={expanded === "panel3"}
                        onChange={handleChange("panel3")}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3bh-content"
                            id="panel3bh-header"
                        >
                            <Typography className={classes.heading}>
                                Gender
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {userinfo.gender}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                The detail is not able to be edited.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion
                        expanded={expanded === "panel4"}
                        onChange={handleChange("panel4")}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4bh-content"
                            id="panel4bh-header"
                        >
                            <Typography className={classes.heading}>
                                Change Password
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container justify="flex-end">
                                <Button
                                    size="small"
                                    component={Link}
                                    to="/update-profile"
                                    variant="contained"
                                    style={{ backgroundColor: "#e65100" }}
                                >
                                    Change
                                </Button>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Box m={1} justifyContent="center">
                    <Button
                        variant="outlined"
                        style={{ backgroundColor:'#ba000d', color:'#fff' }}
                        onClick={handleLogout}
                    >
                        Logout
                    </Button>
                    </Box>
                </div>
            )}
        </Container>
    );
}
